<template>
    <li :class="{active: selected, done: done}">
      <div class="dot">{{ position }}</div>
      <div class="title">{{ title }}</div>
    </li>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    idStep: {
      type: String,
      default() {
        return `${uuid()}`
      },
    },
    position: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default() {
        return `STEP`
      },
    },
    selected: {
      type: Boolean,
      default: false,
    },
    done: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: String,
      default: '',
    },
  },
  components: {
    
  },
  methods: {
    
  },
}
</script>
<style>
  
</style>